import { PrivateRoute } from 'components'
import React, { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const Login = lazy(() => import('../pages/Common/Login'))
const Categories = lazy(() => import('../pages/Common/Categories'))
const Products = lazy(() => import('../pages/Common/Products'))
const Search = lazy(() => import('../pages/Common/Search'))
const CallBack = lazy(() => import('../pages/Common/CallBack'))
const FeedBack = lazy(() => import('../pages/Common/FeedBack'))
const Store = lazy(() => import('../pages/Common/Store'))
const Profile = lazy(() => import('../pages/Common/Profile'))

const Routes = [
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/categories/*',
    element: <Categories />,
  },
  {
    path: '/products/*',
    element: <Products />,
  },
  {
    path: '/search',
    element: <Search />,
  },
  {
    path: '/payment/callback',
    element: <CallBack />,
  },
  {
    path: '/feedback',
    element: <FeedBack />,
  },
  {
    path: '/store/*',
    element: <Store />,
  },
  {
    path: '/profile/*',
    element: (
      <PrivateRoute>
        <Profile />
      </PrivateRoute>
    ),
  },
]

export default Routes
